import { api } from '../core';

interface RemoveFromLightBundleResponse {
  pageIds: string[];
}

interface RemoveFromLightBundleProps {
  bundleId: string;
  abortController?: AbortController;
  pageIds: string[];
}

const removeFromLightBundleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    removeFromLightBundle: builder.mutation<RemoveFromLightBundleResponse, RemoveFromLightBundleProps>({
      query: ({ bundleId, abortController = new AbortController(), pageIds }: RemoveFromLightBundleProps) => ({
        url: 'bundle/remove-from-light',
        method: 'POST',
        signal: abortController.signal,
        body: {
          bundleId: bundleId,
          pageIds: pageIds
        }
      }),
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in addToLightBundle in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useRemoveFromLightBundleMutation } = removeFromLightBundleApi;
